<template>
  <Card :title="$t('pipelines.attach_files')" containerClass="mb-5">
    <template #cardToolbar>
      <span :style="{color: secondaryColor, fontSize: '18px', fontWeight: '600'}">{{formData.attachFiles.length}}</span>
    </template>
    <template #cardBody>
      <div>
        <UploadFile v-show="right" @saveFiles="uploadOpportunityFile" :show-add-files="false" id="upload_file2" :size="2" v-model="formData.files"  :is-disabled="(pipeline?.status == 'WON' || pipeline?.status == 'LOST' || pipeline.status == 'ARCHIVED')"/>
        <FileUploaded  @remove="removeFile" :attach-files="formData.attachFiles" :is-disabled="pipeline?.status == 'WON' || pipeline?.status == 'LOST' || pipeline.status == 'ARCHIVED'"  />

      </div>
    </template>
  </Card>
</template>
<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import Button from "@/components/Button.vue"
import {defineEmits, defineProps, inject, ref, watch} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import UploadFile from "@/components/UploadFile";
import FileUploaded from "@/components/FileUploaded";

const store = useStore()
const router = useRouter()
const route = useRoute()

const emitter = inject('emitter')

const emits = defineEmits(['reset'])

const props = defineProps({files: {type: Array, default: []}, pipeline: Object, right: Boolean})

const secondaryColor = ref('rgba(240, 120, 23, 1)')

const formData = ref({
  id: route.params.id,
  files: [],
  attachFiles: [],
})
watch(() => props.files, (value) => {
  let data = []
  props.files?.map(fileData => {
    let file = fileData.file.split('.')
    let type = getFileType(file[file.length-1])
    data.push({ name: fileData.file, size: fileData.size || 0, url: fileData.file_url, type: type,id:fileData.id })
  })

  formData.value.attachFiles = data
})

const isUploading = ref(false)
const isDeleting = ref(false)


function removeFile(file){
  if(file.id){
    removeOpportunityFile(file.id)
  }
}

function uploadOpportunityFile(){
  isUploading.value = true
  let fileIds = props.files.map(item => item.id)
  let dataIds = formData.value.files.map(item => item.id)
  if(!(JSON.stringify(fileIds) === JSON.stringify(dataIds))){
    store.dispatch('pipelines/uploadPipelineFiles', formData.value)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.files_uploaded"))
        emits('reset')
      })
      .catch((err) => {

      }).finally(() => {
       emitter.emit('removeFileOnDropZone')
      formData.value.files = []
        isUploading.value = false
      })
  }else{
     isUploading.value = false
  }
}

function removeOpportunityFile(id){
  isDeleting.value = true

  store.dispatch('pipelines/removePipelineFile', id)
      .then(res => {
        emits('reset')
        window.toastr['success'](i18n.global.t("notification.files_deleted"))
      })
      .catch((err) => {

      }).finally(() => {

          isDeleting.value = false
      })
}

function getFileType(type){
  let mimeType = ''

  switch (type) {
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'jpeg':
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
    case 'png':
      mimeType = 'image/png';
      break;
    default:
      mimeType = '';
  }

  return mimeType;
}

</script>
